<script>
import { mapStores } from "pinia";

import TgButton from "@/abc-dsk/components/Button/TgButton.vue";
import TgModal from "@/abc-dsk/components/Modal/TgModal.vue";
import { Color, Size } from "@/abc-dsk/options";
import { PACKAGE_GROUP_GYLDENDAL } from "@/common/package-groups-types";
import IconChevronLeft from "@/components/icons/white/IconWhiteChevronLeft.vue";
import IconChevronRight from "@/components/icons/white/IconWhiteChevronRight.vue";
import LogoGyldendal from "@/components/logo/LogoGyldendal.vue";
import ArticleView from "@/components/onboarding/ArticleView.vue";
import ExerciseView from "@/components/onboarding/ExerciseView.vue";
import FrontpageSearchView from "@/components/onboarding/FrontpageSearchView.vue";
import InflectionSchemeView from "@/components/onboarding/InflectionSchemeView.vue";
import LanguageSelectorView from "@/components/onboarding/LanguageSelectorView.vue";
import StartView from "@/components/onboarding/StartView.vue";
import StepProgress from "@/components/StepProgress.vue";
import { useSettingsStore } from "@/stores";

export default {
  name: "OnboardingModal",
  components: {
    ArticleView,
    ExerciseView,
    FrontpageSearchView,
    IconChevronLeft,
    IconChevronRight,
    InflectionSchemeView,
    LogoGyldendal,
    StartView,
    LanguageSelectorView,
    StepProgress,
    TgButton,
    TgModal
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ["close"],
  data() {
    return {
      Color,
      Size,
      view: 0,
      progressLabels: Object.keys(this.$tm("onboarding.stepLabels")).map((key) =>
        this.$rt(this.$tm("onboarding.stepLabels")[key])
      )
    };
  },
  computed: {
    ...mapStores(useSettingsStore),

    packageGroup() {
      return this.settingsStore.preferredPackageGroup;
    },

    isGyldendal() {
      return this.packageGroup?.id === PACKAGE_GROUP_GYLDENDAL;
    },

    btnColor() {
      return this.isGyldendal ? "gyldendal" : "primary";
    }
  },
  methods: {
    prev() {
      this.view -= 1;
    },

    next() {
      this.view += 1;
    },

    close() {
      if (!this.onboardingShown) {
        this.settingsStore.finishOnboarding();
      }

      this.view = 0;
      this.$emit("close");
    }
  }
};
</script>

<template>
  <TgModal
    :color="isGyldendal ? Color.Gyldendal : Color.Primary"
    :size="Size.Lg"
    :is-open="isOpen"
    @close="close()"
  >
    <template v-if="isGyldendal" #modal-header>
      <LogoGyldendal class="text-white" />
    </template>

    <StartView v-show="view === 0" :is-gyldendal="isGyldendal" @skip="close()" @next="next()" />
    <LanguageSelectorView v-show="view === 1" />
    <FrontpageSearchView v-show="view === 2" />
    <ArticleView v-show="view === 3" />
    <InflectionSchemeView v-show="view === 4" />
    <ExerciseView v-show="view === 5" />

    <div v-show="view !== 0" class="row">
      <div class="col-12 d-flex justify-content-between align-items-center">
        <TgButton class="h-100" variant="text" color="grey" @click="prev()">
          <IconChevronLeft class="mr-2" role="presentation" /> {{ $t("onboarding.previous") }}
        </TgButton>
        <StepProgress
          :steps="5"
          :active="view - 1"
          class="d-none d-sm-flex align-items-center"
          :active-class="isGyldendal ? 'step-progress__item--active-gyldendal' : undefined"
          :labels="progressLabels"
        />
        <TgButton v-if="view < 5" :color="btnColor" @click="next()">
          {{ $t("onboarding.next") }} <IconChevronRight class="ml-2" role="presentation" />
        </TgButton>
        <TgButton v-else :color="btnColor" @click="close()">
          {{ $t("onboarding.finish") }} <IconChevronRight class="ml-2" role="presentation" />
        </TgButton>
      </div>
    </div>
  </TgModal>
</template>
